import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-white dark:bg-slate-950 px-6"
          data-testid="error-boundary"
        >
          <div className="text-center max-w-md">
            <h1 className="font-display text-2xl font-semibold text-slate-900 dark:text-slate-50">
              Something went wrong
            </h1>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
              An unexpected error occurred. Please reload the page — your data is safe.
            </p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-boundary-reload"
              className="mt-5 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-slate-900 dark:bg-teal-600 text-white text-sm font-medium hover:bg-slate-800 dark:hover:bg-teal-500 transition-colors"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
